export type CentrifugoMaybeWrappedPayload = unknown;

/**
 * Centrifugo/Centrifuge payload unwrapping helper.
 *
 * In this codebase we have observed WS frames where payload arrives as:
 *   { data: { data: ...actualPayload } }
 * or
 *   { data: ...actualPayload }
 *
 * This helper normalizes it into "actualPayload".
 */
export function unwrapCentrifugoPayload(raw: CentrifugoMaybeWrappedPayload): unknown {
  if (raw && typeof raw === "object") {
    const o = raw as Record<string, unknown>;
    const d1 = o["data"];
    if (d1 && typeof d1 === "object") {
      const d1o = d1 as Record<string, unknown>;
      const d2 = d1o["data"];
      if (d2 !== undefined) return d2;
      return d1;
    }
  }
  return raw;
}

/**
 * Best-effort event extraction used by most realtime channels.
 */
export function extractCentrifugoEventName(raw: unknown): string | null {
  const payload = unwrapCentrifugoPayload(raw);
  if (!payload || typeof payload !== "object") return null;
  const event = (payload as any).event;
  return typeof event === "string" && event.trim() ? event : null;
}